import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { App } from './App';
import { queryClient } from './lib/query-client';
import { LangProvider } from './lib/i18n';
import { ThemeProvider } from './lib/theme';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <LangProvider>
          <App />
          <Toaster position="top-right" richColors />
        </LangProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
